export default __webpack_public_path__ + "platform-for-everyone.png";